import React, { createContext, useContext, useEffect, useState } from 'react';
import appConfig from "./../config";
import { toast } from 'react-toastify';

const RestaurantContext = createContext();

export const RestaurantProvider = ({ slug, restaurantData: initialData, children }) => {
    const [restaurant, setRestaurant] = useState(initialData || null);
    const [menu, setMenu] = useState(initialData?.menu || []);
    const [categories, setCategories] = useState(initialData?.categories || []);
    const [loading, setLoading] = useState(!initialData);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!slug) {
            setError('Не указан ресторан');
            setLoading(false);
            return;
        }

        // Если данные уже переданы извне, используем их
        if (initialData) {
            processRestaurantData(initialData);
            return;
        }

        // Если данных нет, загружаем их
        fetchRestaurantData();
    }, [slug, initialData]);

    const processRestaurantData = (data) => {
        if (!data || typeof data !== 'object') {
            setError('Неверный формат данных');
            return;
        }

        const validMenu = Array.isArray(data.menu)
            ? data.menu.filter(item => item.id && item.title && item.price)
            : [];

        const validCategories = Array.isArray(data.categories)
            ? data.categories.filter(cat => cat.id && cat.title)
            : [];

        const restaurantObj = {
            id: data.id,
            name: data.name,
            slug: data.slug,
            logo: data.logo,
            description: data.description || '',
            address: data.location || data.address || '',
            phone: data.phone || '',
            settings: data.settings || {}
        };

        setRestaurant(restaurantObj);


        setMenu(validMenu);
        setCategories(validCategories);
        setLoading(false);
    };

    const fetchRestaurantData = async () => {
        try {
            setLoading(true);
            setError(null);

            const headers = {
                'Content-Type': 'application/json',
            };

            if (appConfig.token) {
                headers['Authorization'] = `Bearer ${appConfig.token}`;
            }

            const response = await fetch(`${appConfig.endpoint}/restaurant/${slug}`, {
                headers: headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            processRestaurantData(data);

        } catch (error) {
            console.error('Ошибка при загрузке данных ресторана:', error);
            setError(error.message || 'Ошибка при загрузке данных');
            toast.error('Не удалось загрузить данные ресторана');
            setLoading(false);
        }
    };

    const refetch = async () => {
        setLoading(true);
        setError(null);
        await fetchRestaurantData();
    };

    const getDishById = (dishId) => {
        return menu.find(item => item.id === dishId) || null;
    };

    const getDishesByCategory = (categoryId) => {
        return menu.filter(item => item.category_id === categoryId);
    };

    const value = {
        restaurant,
        menu,
        categories,
        loading,
        error,
        refetch,
        getDishById,
        getDishesByCategory,
        isAuthenticated: !!appConfig.token,
    };

    return (
        <RestaurantContext.Provider value={value}>
            {children}
        </RestaurantContext.Provider>
    );
};

export const useRestaurant = () => {
    const context = useContext(RestaurantContext);
    if (!context) {
        throw new Error('useRestaurant must be used within a RestaurantProvider');
    }
    return context;
};